var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("branch_picker_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('branch_picker_page.form_desc'))
    }
  }), _c('div', {
    staticClass: "card pt-2 px-2"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_vm.filter != null ? _c('div', [_c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.filter == 'qrcode' ? _c('div', {
    staticClass: "qrcode-panel"
  }, [_c('QRCodeScanner', {
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.onScan
    }
  })], 1) : !_vm.showLoading && _vm.filter == 'manual' ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.barcode,
      expression: "barcode"
    }],
    staticClass: "search__input m-auto w-100",
    domProps: {
      "value": _vm.barcode
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value;
      }, _vm.barcodeFormatter]
    }
  })]) : _vm._e()], 1)], 1) : _vm._e(), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "p-4 rounded picker-content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('branch_picker_page.content'))
    }
  })]) : _vm._e()], 1)])]), _vm.getModuleConfig('branch_picker_page.button_text') || _vm.getModuleConfig('branch_picker_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    attrs: {
      "disabled": !_vm.barcode || _vm.showLoading
    },
    on: {
      "click": _vm.bindStore
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("branch_picker_page.button_text")))]), _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.getModuleConfig('branch_picker_page.cancel_button_text'),
      "button-url": _vm.getModuleConfig('branch_picker_page.cancel_button_url'),
      "type": _vm.getModuleConfig('branch_picker_page.cancel_button_action'),
      "disabled": _vm.showLoading
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }